import React from 'react';
import styled from 'styled-components';
import SectionExamRol from './SectionExamRol';
import Spinner from '@/presentation/components/Spinner';
import ErrorMessage from '@/presentation/components/Error';
import EmptyDataStateMessage from '@/presentation/reusables/EmptyDataStateMessage';
import { ContainerLoadInit } from '@/presentation/modules/procedures/modules/requests/FullCycleDiscount/style';
import WarningMessage from '@/presentation/reusables/WarningMessage';

const ContainerSectionExamsRole = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

interface IRenderContentProps {
  isLoading: boolean;
  hasError?: boolean;
  dataExamRol: any;
}

const RenderContentExamRol = ({
  isLoading,
  hasError,
  dataExamRol
}: IRenderContentProps) => {
  if (isLoading) {
    return (
      <ContainerLoadInit>
        <Spinner height={80} colorText="#5B36F2" />
      </ContainerLoadInit>
    );
  }
  if (hasError) return <ErrorMessage />;
  if (
    !dataExamRol ||
    !Object.values(dataExamRol).some(
      (exams) =>
        Array.isArray(exams) && exams.some((e) => e?.courses?.length > 0)
    )
  ) {
    return (
      <EmptyDataStateMessage message="Por el momento no hay un Rol de exámenes disponible" />
    );
  }
  return (
    <ContainerSectionExamsRole>
      <SectionExamRol dataExamRol={dataExamRol} />
      <WarningMessage message="Sobre es el código del exámen asignado a tu sección." />
    </ContainerSectionExamsRole>
  );
};

export default RenderContentExamRol;
